var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2619 3.4048L2.4048 22.2619L0.738053 20.5952L19.5952 1.73805L21.2619 3.4048Z",
    fill: "#6A84C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 1L22 7.28571V1H15.7143Z",
    fill: "#6A84C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28571 23L0 16.7143V23H6.28571Z",
    fill: "#6A84C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.73799 3.4048L19.5951 22.2619L21.2619 20.5952L2.40474 1.73805L0.73799 3.4048Z",
    fill: "#6A84C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28575 1L3.14713e-05 7.28571V1H6.28575Z",
    fill: "#6A84C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 23L22 16.7143V23H15.7143Z",
    fill: "#6A84C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.0805387d7caae17ef925b5ac873af8c2.svg";
export { ForwardRef as ReactComponent };